export default __webpack_public_path__ + "static/media/gif-samples.f21def58.gif";